import { MutationHookOptions, QueryHookOptions } from '@apollo/client'
import { errorHandler } from 'hooks/errorHandler'

export const DefaultQueryHookOptions: QueryHookOptions<any, any> = {
  onError: errorHandler,
  fetchPolicy: 'no-cache',
  notifyOnNetworkStatusChange: true,
}

export const DefaultMutationHookOptions: MutationHookOptions<
  any,
  any,
  any,
  any
> = {
  onError: errorHandler,
  fetchPolicy: 'no-cache',
  notifyOnNetworkStatusChange: true,
}
